import { render, staticRenderFns } from "./Extruder.vue?vue&type=template&id=73645089&scoped=true"
import script from "./Extruder.vue?vue&type=script&lang=js"
export * from "./Extruder.vue?vue&type=script&lang=js"
import style0 from "./Extruder.vue?vue&type=style&index=0&id=73645089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73645089",
  null
  
)

export default component.exports